var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pin-number",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2991",
    "data-name": "Path 2991",
    d: "M4.828,376.848l-1.313.427v-1.38h-1.7v1.387l-1.3-.414L0,378.486l1.285.41-.808,1.112,1.376,1,.811-1.117.811,1.117,1.376-1-.811-1.117,1.313-.427Z",
    transform: "translate(0 -358.008)",
    fill: "#90348a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2992",
    "data-name": "Path 2992",
    d: "M124.43,376.848l-1.313.427v-1.38h-1.7v1.38l-1.313-.427-.525,1.617,1.313.427-.811,1.117,1.376,1,.811-1.117.811,1.117,1.376-1-.811-1.117,1.313-.427Z",
    transform: "translate(-113.093 -358.008)",
    fill: "#90348a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2993",
    "data-name": "Path 2993",
    d: "M244.43,376.848l-1.313.427v-1.38h-1.7v1.38l-1.313-.427-.525,1.617,1.313.427-.811,1.117,1.376,1,.811-1.117.811,1.117,1.376-1-.811-1.117,1.313-.427Z",
    transform: "translate(-226.585 -358.008)",
    fill: "#90348a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2994",
    "data-name": "Path 2994",
    d: "M362.011,405.894h3.4v1.7h-3.4Z",
    transform: "translate(-342.31 -386.308)",
    fill: "#90348a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2995",
    "data-name": "Path 2995",
    d: "M452.011,405.894h3.4v1.7h-3.4Z",
    transform: "translate(-427.412 -386.308)",
    fill: "#90348a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2996",
    "data-name": "Path 2996",
    d: "M32.011,45.894H56.5v3.4H32.011Z",
    transform: "translate(-30.197 -45.894)",
    fill: "#90348a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2997",
    "data-name": "Path 2997",
    d: "M56.5,135.894H32.011v11.9H56.5Zm-3.265,6.8h-4.9V141h4.9Z",
    transform: "translate(-30.197 -131.143)",
    fill: "#90348a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPin);
export default __webpack_public_path__ + "static/media/icon_pin.98889e354e470d82f6a7820653ae158f.svg";
export { ForwardRef as ReactComponent };